
















































import { Component, Vue } from "vue-property-decorator";
import { Button, Dialog } from "vant";

@Component({
  name: 'FaceFail',
  components: {
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component
  }
})
export default class FaceFail extends Vue {
  tip: any = "";
  action: any = "";
  open_status: any = "";
  showCommonCreateDialog = false;

  get isTwoBtn() {
    return this.$route.query.isTwoBtn == "1";
  }

  created() {
    const { tip, action, open_status } = this.$route.query;
    this.tip = tip;
    this.action = action;
    this.open_status = open_status;
  }

  handleCommonCreateAccount() {
    const { open_status, order_no } = this.$route.query;
    const params = {
      open_status,
      order_no,
      open_type: 1,
      verify_action: 3,
      is_verify: 0
    };
    (this as any).$apis
      .saveFaceInfo(params)
      .then(res => {
        
        this.$router.push({
          path: "/personal-info-supply",
          query: {
            open_status: this.open_status,
            open_type: "1" //常规开户
          }
        });
      })
      .catch(e => {
        
      });
  }

  handleResetVerify() {
    const { open_status } = this.$route.query;
    this.$router.push({
      path: "face-record",
      query: {
        isTwoBtn: "0",
        open_status
      }
    });
  }
}
